import {css} from 'styled-components';
export const cardBreakpoint = '72.125rem';
export const mobileBreakpoint = '60rem';
export const displayNoneMobile = css`
  @media (max-width: ${mobileBreakpoint}) {
    display: none;
  }
`;
